import { toast } from 'react-toastify';
import appApi from '../../../../../../../../api/app-api';
import { ExamSessionDetails } from '../../../../../../../../api/types/programs/course/exams/response/exam-metadata';

export const deleteExamSessionOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  examId: number | undefined,
  examSessionId: number | undefined,
  setLoading: (examSessionId: number | null) => any,
  setSessionDetails: (sessions: ExamSessionDetails[]) => any,
) => {
  try {
    if (!programId || !courseId || !examId || !examSessionId) {
      toast.warn(
        'לא ניתן לאתר את המזהה של התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }

    setLoading(examSessionId);
    const res = await appApi.deleteExamSession(
      programId,
      courseId,
      examId,
      examSessionId,
    );

    setLoading(null);

    setSessionDetails(res.data.body);
  } catch (e) {
    setLoading(null);
    toast.warn('לא ניתן למחוק מועד עם שיבוצים ו/או מועד שכבר קרה');
  }
};
